
import Vue from "vue";
import WorldViewForm from "@/components/organisms/WorldViewForm.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import ImageSelector from "@/components/molecules/ImageSelector.vue";
import { submitImage } from "@/lib/image-save";
import { cloneDeep } from "lodash";
import { UpdateWorldView, WorldView } from "@/lib/models";
import { handleShortcutKeys, TriggerKey } from "@/lib/utils/keyboardShortcuts";

export default Vue.extend<Data, Methods, Computed, Props>({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { WorldViewForm, ButtonDefault, ImageSelector },
  props: {
    novelId: String,
    worldViewId: String,
  },
  data() {
    return {
      model: {
        name: "",
        detail: [],
        additionalColumn: [],
      },
      image: null,
      unbindShortcutKeys: null,
    };
  },
  async created() {
    const {
      worldView: { name, detail, additionalColumn, image },
    } = this;
    this.image = image;
    this.model = { name, detail, additionalColumn };

    // 保存ボタンのショートカットキーの有効化と解除関数の取得
    this.unbindShortcutKeys = handleShortcutKeys([
      { trigger: TriggerKey.Meta, keys: ["s"], callback: this.submit },
      { trigger: TriggerKey.Ctrl, keys: ["s"], callback: this.submit },
    ]);
  },
  beforeDestroy() {
    // コンポーネントが破棄される前に保存ボタンのショートカットキーを解除
    if (this.unbindShortcutKeys) this.unbindShortcutKeys();
  },
  computed: {
    worldView() {
      return cloneDeep(this.$store.getters["worldViewModule/worldView"](this.worldViewId));
    },
    imagePath() {
      const { novelId, worldViewId, image } = this;
      if (!image) return null;
      if (image.startsWith("file:")) {
        return `file:novels/${novelId}/worldviews/${worldViewId}.jpg`;
      }
      if (image.startsWith("preset:")) {
        return image;
      }
      return null;
    },
  },
  methods: {
    change() {
      this.setModified(true);
    },
    async submit() {
      const { novelId, worldViewId, model, image } = this;
      const { additionalColumn } = model;
      model.additionalColumn = additionalColumn.filter((item) => item.label || item.content);

      const updateWorldViewInput: UpdateWorldView = {
        novelId,
        worldViewId,
        image,
        ...model,
      };
      await this.$store.dispatch("worldViewModule/updateWorldView", updateWorldViewInput);
      await submitImage(`novels/${novelId}/worldviews/${worldViewId}.jpg`);

      this.$notify({
        title: this.$t('common.saved'),
        type: "success",
      });

      this.setModified(false);

      this.$router.push({
        name: "worldViews",
        params: { novelId, worldViewId },
      });
    },
  },
});

interface Props {
  novelId: string;
  worldViewId: string;
}

interface Data {
  model: {
    name: string;
    detail: any[];
    additionalColumn: any[];
  };
  image: string | null;
  unbindShortcutKeys: (() => void) | null;
}

interface Computed {
  worldView: WorldView;
  imagePath: string | null;
}

interface Methods {
  change(): void;
  submit(): Promise<void>;
}
